"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_calendar_1 = __importDefault(require("react-calendar"));
var moment_1 = __importDefault(require("moment"));
var lodash_1 = require("lodash");
var Calendar = function (props) {
    var selectDate = props.selectDate ? new Date(props.selectDate) : undefined;
    var activeDates = props.activeDates.reduce(function (map, _a) {
        var value = _a.value, path = _a.path;
        map.set(value, path);
        return map;
    }, new Map());
    var minDate = (0, lodash_1.min)(props.activeDates.map(function (_a) {
        var value = _a.value;
        return new Date(value);
    }));
    var maxDate = (0, lodash_1.max)(props.activeDates.map(function (_a) {
        var value = _a.value;
        return new Date(value);
    }));
    var tileDisabled = function (_a) {
        var date = _a.date, view = _a.view;
        return view === 'month' ? !activeDates.has((0, moment_1.default)(date).format('YYYY-MM-DD')) : false;
    };
    var handleClickDay = function (value) {
        var path = activeDates.get((0, moment_1.default)(value).format('YYYY-MM-DD'));
        window.location.href = path;
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h3", { className: "coMarketCalendar-Title" }, "\u53E4\u7269\u5E02\u5834\u30AB\u30EC\u30F3\u30C0\u30FC"),
        react_1.default.createElement(react_calendar_1.default, { className: "coMarketCalendar-Container", defaultValue: selectDate, maxDate: maxDate, minDate: minDate, onClickDay: handleClickDay, tileDisabled: tileDisabled, next2Label: null, prev2Label: null }),
        props.showMarketTopLink && (react_1.default.createElement("div", { className: "coMarketCalendar-MarketTopLinkText" },
            "\u203B\u8CB7\u53D6\u696D\u8005\u5411\u3051\u306E",
            react_1.default.createElement("a", { href: "/market/", className: "coMarketCalendar-MarketTopLinkText_Link" }, "\u53E4\u7269\u5E02\u5834\u30AB\u30EC\u30F3\u30C0\u30FC"),
            "\u3067\u3059"))));
};
exports.default = Calendar;
